angular.module 'zc.projects'

.factory 'BaseProjectConfirm', ($q, MongoHistory, MongoSession) ->
  class BaseProjectConfirm
    constructor: (@resourceName, @fields) ->

    requestRecentHistories: (scope, elem, attrs) ->
      promises = for device in ['pc', 'sp']
        MongoHistory.find
          apikey: scope.apikey
          page_types: 'item'
          device: device
          opened_at:
            $gte: moment().subtract(1, 'hour').toDate()
        ,
          limit: 20
      $q.all(promises).then ([pc, sp]) ->
        pc.concat(sp)

    requestRecentCartSessions: (scope, elem, attrs) ->
      promises = for device in ['pc', 'sp']
        MongoSession.find
          apikey: scope.apikey
          'page_types_counts.cart':
            $gte: 1
          'cart_button_click_count':
            $gte: 1
          device: device
          opened_at:
            $gte: moment().subtract(1, 'day').toDate()
            $lt: moment().subtract(1, 'hour').toDate()
        ,
          limit: 20
      $q.all(promises).then ([pc, sp]) ->
        pc.concat(sp)

    createDirective: (request) ->
      restrict: 'E'
      scope:
        apikey: '='
        showAlertDevices: '='
      templateUrl: '/templates/projects.settings/base_project_confirm.html'
      link: (scope, elem, attrs) =>
        scope.resourceName = @resourceName
        request(scope, elem, attrs).then (items) =>
          scope.showPC = false
          scope.showSP = false
          scope.foundPC = false
          scope.foundSP = false
          scope.itemsPC = []
          scope.itemsSP = []
          for item in items
            val = null
            for field in @fields
              val = item[field]
              break if val
            continue unless val
            if item.device is 'pc'
              scope.foundPC = true
              scope.itemsPC.push val
            if item.device is 'sp'
              scope.foundSP = true
              scope.itemsSP.push val
          if scope.showAlertDevices
            if 'pc' in scope.showAlertDevices and not scope.foundPC
              scope.showPC = true
            if 'sp' in scope.showAlertDevices and not scope.foundSP
              scope.showSP = true
          else
            scope.showPC = true
            scope.showSP = true



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/base_project_confirm.directive.coffee